import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "cpanel"
    }}>{`cPanel`}</h1>
    <blockquote>
      <p parentName="blockquote">{`It's quite hard to debug any deployment issue on the cPanel or any managed server as the provider manages this type of server, and they've complete control of the server.  And for that, We don't recommend Cpanel or any managed server for deployment. We suggest you use any VPS server where you have complete control of it. you can purchase any $5 – $10/mo server from amazon lightsail, ec2 or digitalocean or any ubuntu server`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`If you still decide to proceed with panel based server, our support team won't be able to help you. We have put some resources for Cpanel in this documentation section to help our users to get started but other than that, we don't have much to offer with Cpanel or any Managed Server`}</p>
    </blockquote>
    <h2 {...{
      "id": "access-server"
    }}>{`Access Server`}</h2>
    <p>{`To install the API, access the server using the cPanel terminal first,`}</p>
    <p><img alt="Terminal.png" src={require("../images/Terminal.png")} /></p>
    <p>{`If you don't find the terminal, then login to your local computer terminal or `}<a parentName="p" {...{
        "href": "https://www.putty.org/"
      }}>{`putty`}</a>{` for Windows using SSH.`}</p>
    <p><img alt="SSHcPanel.png" src={require("../images/SSHcPanel.png")} /></p>
    <p>{`After enabling the ssh login to your server using ssh,`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you dont't see any option, then contact your hosting provider as cPanel control by hosting provider.`}</p>
    </blockquote>
    <p>{`After logging in, Check if the composer is already installed or not using this command,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`composer -v
`}</code></pre>
    <p><img alt="ComposerV.png" src={require("../images/ComposerV.png")} /></p>
    <p>{`If composer is not installed then, install `}<inlineCode parentName="p">{`composer`}</inlineCode>{` to your server.`}</p>
    <p>{`Check this `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=qJJLUwcFRzY"
      }}>{`YouTube Video`}</a>{` for install `}<inlineCode parentName="p">{`composer`}</inlineCode>{` on your server,`}</p>
    <p>{`After that, check the PHP version using,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`php -v
`}</code></pre>
    <p>{`make sure it's `}<inlineCode parentName="p">{`8.1`}</inlineCode></p>
    <h2 {...{
      "id": "create-subdomains"
    }}>{`Create Subdomains`}</h2>
    <p>{`Now create two subdomains, for example,`}</p>
    <pre><code parentName="pre" {...{}}>{`-> your_domain.com -> host frontend store.
-> api.your_domain.com -> host laravel API.
-> admin.your_domain.com -> host admin dashboard.
`}</code></pre>
    <p>{`Or if you want to host all the script on subdomains, then create subdomains like this,`}</p>
    <pre><code parentName="pre" {...{}}>{`-> store.your_domain.com -> host frontend store.
-> api.your_domain.com -> host laravel API.
-> admin.your_domain.com -> host admin dashboard.
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`After creating domain/subdomains, make sure all the domain/subdomains are HTTPS enabled. Please contact your hosting provider to enable this, as most hosting providers provide some sort of free SSL.`}</p>
    </blockquote>
    <h2 {...{
      "id": "install-api"
    }}>{`Install API`}</h2>
    <ol>
      <li parentName="ol">{`Extract the `}<inlineCode parentName="li">{`pickbazar`}</inlineCode>{` package that you download from `}<inlineCode parentName="li">{`CodeCanyon.`}</inlineCode></li>
      <li parentName="ol">{`On that folder, you'll get another `}<inlineCode parentName="li">{`zip`}</inlineCode>{` called `}<inlineCode parentName="li">{`pickbazar-laravel.zip`}</inlineCode>{`.`}</li>
      <li parentName="ol">{`Now extract this `}<inlineCode parentName="li">{`pickbazar-laravel.zip`}</inlineCode>{` file.`}</li>
      <li parentName="ol">{`On that file, you'll get a folder called `}<inlineCode parentName="li">{`api`}</inlineCode></li>
    </ol>
    <p>{`Now upload this `}<inlineCode parentName="p">{`api`}</inlineCode>{` folder to the `}<inlineCode parentName="p">{`api.your_domain.com`}</inlineCode>{` folder in your server`}</p>
    <p><img alt="UploadAPI.png" src={require("../images/UploadAPI.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Make sure your `}<inlineCode parentName="p">{`api.your_domain.com`}</inlineCode>{` subdomain `}<inlineCode parentName="p">{`Document Root`}</inlineCode>{` points to that `}<inlineCode parentName="p">{`api/public`}</inlineCode>{` folder.`}</p>
    </blockquote>
    <p><img alt="APIDocRoot.png" src={require("../images/APIDocRoot.png")} /></p>
    <p>{`Now create a MySQL database and user from MySQL wizard`}</p>
    <p><img alt="CreateMySQL.png" src={require("../images/CreateMySQL.png")} /></p>
    <p>{`After creating the MySQL database, go to your `}<inlineCode parentName="p">{`api`}</inlineCode>{` folder from your cPanel file manager and copy `}<inlineCode parentName="p">{`.env.example`}</inlineCode>{` to `}<inlineCode parentName="p">{`.env.`}</inlineCode></p>
    <p><img alt="APIEnv.png" src={require("../images/APIEnv.png")} /></p>
    <p>{`After the copy, edit `}<inlineCode parentName="p">{`.env`}</inlineCode>{` and add MySQL credentials,`}</p>
    <p><img alt="EditEnv.png" src={require("../images/EditEnv.png")} /></p>
    <p>{`Also, add `}<inlineCode parentName="p">{`https://YOUR_DOMAIN.COM/api`}</inlineCode>{` to `}<inlineCode parentName="p">{`APP_URL`}</inlineCode>{`. Without this, the `}<inlineCode parentName="p">{`upload`}</inlineCode>{` function will be broken.`}</p>
    <p><img alt="APIDomain.png" src={require("../images/APIDomain.png")} /></p>
    <p>{`Then go to your `}<inlineCode parentName="p">{`ssh terminal`}</inlineCode>{` again and,`}</p>
    <p>{`go to `}<inlineCode parentName="p">{`api`}</inlineCode>{` folder and run,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`composer install
`}</code></pre>
    <p>{`If `}<inlineCode parentName="p">{`composer`}</inlineCode>{` installs all the packages successfully, then run this command on the `}<inlineCode parentName="p">{`api`}</inlineCode>{` folder,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`php artisan key:generate

php artisan marvel:install
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`You'll get several confirmations for migration, dummy data, and admin account. Make sure you check the confirmation step and take the necessary actions based on your requirement.`}</p>
    </blockquote>
    <p>{`After that, run this command to link storage,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`php artisan storage:link
`}</code></pre>
    <p>{`After install, go to your `}<inlineCode parentName="p">{`api.your_domain_name.com,`}</inlineCode>{` and you'll get a webpage like this,`}</p>
    <p><img alt="AccessAPI.png" src={require("../images/AccessAPI.png")} /></p>
    <h2 {...{
      "id": "install-frontend"
    }}>{`Install FrontEnd`}</h2>
    <p>{`Before proceeding next step, make sure you already create two subdomains like this,`}</p>
    <pre><code parentName="pre" {...{}}>{`-> your_domain.com -> host frontend store.
-> admin.your_domain.com -> host admin dashboard.
`}</code></pre>
    <p>{`OR`}</p>
    <pre><code parentName="pre" {...{}}>{`-> store.your_domain.com -> host frontend store.
-> admin.your_domain.com -> host admin dashboard.
`}</code></pre>
    <h3 {...{
      "id": "frontend-project-build"
    }}>{`FrontEnd Project Build`}</h3>
    <blockquote>
      <p parentName="blockquote">{`It's not possible to run both REST and GraphQL versions at the same time. So make sure to follow only the `}<inlineCode parentName="p">{`For REST`}</inlineCode>{` section or `}<inlineCode parentName="p">{`For GraphQL`}</inlineCode>{` section.`}</p>
    </blockquote>
    <p>{`Typescript requires a huge chunk of memory to build the project, so if your server has at least 8gb+ of memory, then you can build the project on your server directly. If not, then build the project on your server, then move the folder to the server then serve the project. We'll do the second method in this tutorial.`}</p>
    <blockquote>
      <p parentName="blockquote">{`We'll suggest you build the frontend part on your computer and then upload the build file to the server.`}</p>
    </blockquote>
    <h3 {...{
      "id": "step-1---build-custom-server"
    }}>{`step 1 - Build Custom Server`}</h3>
    <p>{`go to your `}<inlineCode parentName="p">{`pickbazar-laravel`}</inlineCode>{` folder`}</p>
    <h4 {...{
      "id": "shop-rest"
    }}>{`shop rest`}</h4>
    <p>{`Create custom server for `}<inlineCode parentName="p">{`shop rest`}</inlineCode>{`,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`nano shop/server.js
`}</code></pre>
    <p>{`and paste this code,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// server.js
const { createServer } = require('http')
const { parse } = require('url')
const next = require('next')

const dev = process.env.NODE_ENV !== 'production'
const app = next({ dev })
const handle = app.getRequestHandler()

app.prepare().then(() => {
  createServer((req, res) => {
    // Be sure to pass \`true\` as the second argument to \`url.parse\`.
    // This tells it to parse the query portion of the URL.
    const parsedUrl = parse(req.url, true)
    const { pathname, query } = parsedUrl

    if (pathname === '/a') {
      app.render(req, res, '/a', query)
    } else if (pathname === '/b') {
      app.render(req, res, '/b', query)
    } else {
      handle(req, res, parsedUrl)
    }
  }).listen(3003, (err) => {
    if (err) throw err
    console.log('> Ready on http://localhost:3003')
  })
})
`}</code></pre>
    <p>{`Now update package.json for `}<inlineCode parentName="p">{`shop rest`}</inlineCode>{`,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`nano shop/package.json
`}</code></pre>
    <p>{`and replace `}<inlineCode parentName="p">{`start`}</inlineCode>{` script with this,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"start": "NODE_ENV=production node server.js"
`}</code></pre>
    <p><img alt="ReplaceOldOne.png" src={require("../images/ReplaceOldOne.png")} /></p>
    <h4 {...{
      "id": "admin-rest"
    }}>{`admin rest`}</h4>
    <p>{`Similarly, create custom server for `}<inlineCode parentName="p">{`admin rest`}</inlineCode>{`,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`nano admin/rest/server.js
`}</code></pre>
    <p>{`and paste this code,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// server.js
const { createServer } = require('http')
const { parse } = require('url')
const next = require('next')

const dev = process.env.NODE_ENV !== 'production'
const app = next({ dev })
const handle = app.getRequestHandler()

app.prepare().then(() => {
  createServer((req, res) => {
    // Be sure to pass \`true\` as the second argument to \`url.parse\`.
    // This tells it to parse the query portion of the URL.
    const parsedUrl = parse(req.url, true)
    const { pathname, query } = parsedUrl

    if (pathname === '/a') {
      app.render(req, res, '/a', query)
    } else if (pathname === '/b') {
      app.render(req, res, '/b', query)
    } else {
      handle(req, res, parsedUrl)
    }
  }).listen(3002, (err) => {
    if (err) throw err
    console.log('> Ready on http://localhost:3002')
  })
})
`}</code></pre>
    <p>{`Now update package.json for `}<inlineCode parentName="p">{`admin rest`}</inlineCode>{`,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`nano admin/rest/package.json
`}</code></pre>
    <p>{`and replace `}<inlineCode parentName="p">{`start`}</inlineCode>{` script with this,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"start": "NODE_ENV=production node server.js"
`}</code></pre>
    <h4 {...{
      "id": "admin-graphql"
    }}>{`admin graphql`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Skip this step if you want to use REST API`}</p>
    </blockquote>
    <p>{`Create custom server for `}<inlineCode parentName="p">{`admin graphql`}</inlineCode>{`,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`nano admin/graphql/server.js
`}</code></pre>
    <p>{`and paste this code,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// server.js
const { createServer } = require('http')
const { parse } = require('url')
const next = require('next')

const dev = process.env.NODE_ENV !== 'production'
const app = next({ dev })
const handle = app.getRequestHandler()

app.prepare().then(() => {
  createServer((req, res) => {
    // Be sure to pass \`true\` as the second argument to \`url.parse\`.
    // This tells it to parse the query portion of the URL.
    const parsedUrl = parse(req.url, true)
    const { pathname, query } = parsedUrl

    if (pathname === '/a') {
      app.render(req, res, '/a', query)
    } else if (pathname === '/b') {
      app.render(req, res, '/b', query)
    } else {
      handle(req, res, parsedUrl)
    }
  }).listen(3000, (err) => {
    if (err) throw err
    console.log('> Ready on http://localhost:3000')
  })
})
`}</code></pre>
    <p>{`Now update package.json for `}<inlineCode parentName="p">{`admin graphql`}</inlineCode>{`,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`nano admin/graphql/package.json
`}</code></pre>
    <p>{`and replace `}<inlineCode parentName="p">{`start`}</inlineCode>{` script with this,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"start": "NODE_ENV=production node server.js"
`}</code></pre>
    <h4 {...{
      "id": "shop-graphql"
    }}>{`shop graphql`}</h4>
    <blockquote>
      <p parentName="blockquote">{`You can skip this step if you want to use REST API`}</p>
    </blockquote>
    <p>{`Create custom server for `}<inlineCode parentName="p">{`shop graphql`}</inlineCode>{`,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`nano shop/server.js
`}</code></pre>
    <p>{`and paste this code,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// server.js
const { createServer } = require('http')
const { parse } = require('url')
const next = require('next')

const dev = process.env.NODE_ENV !== 'production'
const app = next({ dev })
const handle = app.getRequestHandler()

app.prepare().then(() => {
  createServer((req, res) => {
    // Be sure to pass \`true\` as the second argument to \`url.parse\`.
    // This tells it to parse the query portion of the URL.
    const parsedUrl = parse(req.url, true)
    const { pathname, query } = parsedUrl

    if (pathname === '/a') {
      app.render(req, res, '/a', query)
    } else if (pathname === '/b') {
      app.render(req, res, '/b', query)
    } else {
      handle(req, res, parsedUrl)
    }
  }).listen(3001, (err) => {
    if (err) throw err
    console.log('> Ready on http://localhost:3001')
  })
})
`}</code></pre>
    <p>{`Now update package.json for `}<inlineCode parentName="p">{`shop graphql`}</inlineCode>{`,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`nano shop/package.json
`}</code></pre>
    <p>{`and replace `}<inlineCode parentName="p">{`start`}</inlineCode>{` script with this,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"start": "NODE_ENV=production node server.js"
`}</code></pre>
    <h3 {...{
      "id": "step-2---install--build"
    }}>{`Step 2 - Install & Build`}</h3>
    <p>{`go to your `}<inlineCode parentName="p">{`pickbazar-laravel`}</inlineCode>{` folder`}</p>
    <p>{`To install all the npm packages run this command,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn
`}</code></pre>
    <h3 {...{
      "id": "step-3---build-the-project"
    }}>{`Step 3 - Build the project`}</h3>
    <p>{`At first, we've to copy the sample `}<inlineCode parentName="p">{`.env.template`}</inlineCode>{` to production `}<inlineCode parentName="p">{`.env`}</inlineCode>{` for the shop and admin first.`}</p>
    <p>{`If you want to use `}<inlineCode parentName="p">{`REST API.,`}</inlineCode>{` then follow `}<a parentName="p" {...{
        "href": "#for-rest"
      }}>{`REST Procedure`}</a>{`, or if you want to use `}<inlineCode parentName="p">{`GraphQL`}</inlineCode>{` API, then follow `}<a parentName="p" {...{
        "href": "#for-graphql"
      }}>{`GraphQL Procedure`}</a></p>
    <h4 {...{
      "id": "for-rest"
    }}>{`For REST`}</h4>
    <p>{`Go to,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`cd shop
`}</code></pre>
    <p>{`then use this command to copy,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`cp .env.template .env
`}</code></pre>
    <p>{`Now edit .env and add you `}<inlineCode parentName="p">{`API`}</inlineCode>{` url to `}<inlineCode parentName="p">{`.env`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`nano .env
`}</code></pre>
    <p>{`and use`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`NEXT_PUBLIC_REST_API_ENDPOINT=https://api.YOUR_DOMAIN.com/
`}</code></pre>
    <p>{`and`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`FRAMEWORK_PROVIDER="rest"
`}</code></pre>
    <p>{`then copy `}<inlineCode parentName="p">{`tsconfig.rest.json`}</inlineCode>{` content to `}<inlineCode parentName="p">{`tsconfig.json`}</inlineCode></p>
    <p>{`After that, go to the `}<inlineCode parentName="p">{`admin -> rest`}</inlineCode>{` folder,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`cd ../admin/rest
`}</code></pre>
    <p>{`then use this command to copy,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`cp .env.template .env
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`nano .env
`}</code></pre>
    <p>{`and use`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`NEXT_PUBLIC_REST_API_ENDPOINT=https://api.YOUR_DOMAIN.com/
`}</code></pre>
    <p>{`Now go to the `}<inlineCode parentName="p">{`pickbazar-laravel`}</inlineCode>{` folder,`}</p>
    <p>{`and run,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn build:shop-rest
yarn build:admin-rest
`}</code></pre>
    <h4 {...{
      "id": "for-graphql"
    }}>{`For GraphQL`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Skip this step if you want to use REST API`}</p>
    </blockquote>
    <p>{`and go to,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`cd shop
`}</code></pre>
    <p>{`then use this command to copy,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`cp .env.template .env
`}</code></pre>
    <p>{`Now edit .env and add you `}<inlineCode parentName="p">{`API`}</inlineCode>{` url to `}<inlineCode parentName="p">{`.env`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`nano .env
`}</code></pre>
    <p>{`and use`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`NEXT_PUBLIC_GRAPHQL_API_ENDPOINT=https://api.YOUR_DOMAIN.com/
`}</code></pre>
    <p>{`and`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`FRAMEWORK_PROVIDER="graphql"
`}</code></pre>
    <p>{`then copy `}<inlineCode parentName="p">{`tsconfig.graphql.json`}</inlineCode>{` content to `}<inlineCode parentName="p">{`tsconfig.json`}</inlineCode></p>
    <p>{`After that, go to the `}<inlineCode parentName="p">{`admin -> graphql`}</inlineCode>{` folder,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`cd ../admin/graphql
`}</code></pre>
    <p>{`then use this command to copy,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`cp .env.template .env
`}</code></pre>
    <p>{`Again edit `}<inlineCode parentName="p">{`.env`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`nano .env
`}</code></pre>
    <p>{`and use`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`NEXT_PUBLIC_GRAPHQL_API_ENDPOINT=https://api.YOUR_DOMAIN.com/
`}</code></pre>
    <p>{`Now go to the `}<inlineCode parentName="p">{`pickbazar-laravel`}</inlineCode>{` folder,`}</p>
    <p>{`and run,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn build:shop-gql
yarn build:admin-gql
`}</code></pre>
    <p>{`After build the project upload the`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`shop`}</inlineCode>{` to `}<inlineCode parentName="li">{`root_domain -> public_html`}</inlineCode>{` folder`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`admin-rest`}</inlineCode>{` to `}<inlineCode parentName="li">{`admin.your_domain.com`}</inlineCode>{` folder`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`For graphql upload admin-graphql instead of admin-rest`}</p>
    </blockquote>
    <p><inlineCode parentName="p">{`shop`}</inlineCode>{`,`}</p>
    <p><img alt="UploadRoot.png" src={require("../images/UploadRoot.png")} /></p>
    <p><inlineCode parentName="p">{`shop-admin`}</inlineCode>{`,`}</p>
    <p><img alt="UploadAdmin.png" src={require("../images/UploadAdmin.png")} /></p>
    <h2 {...{
      "id": "install-nodejs-project"
    }}>{`Install NodeJs Project`}</h2>
    <p>{`We'll run both `}<inlineCode parentName="p">{`shop`}</inlineCode>{` and `}<inlineCode parentName="p">{`admin`}</inlineCode>{` using the cPanel NodeJs application in this step.`}</p>
    <p>{`To do that at first go to the NodeJS section from your cPanel,`}</p>
    <p>{`For `}<inlineCode parentName="p">{`shop`}</inlineCode>{`,`}</p>
    <p><img alt="NodeJsLocation.png" src={require("../images/NodeJsLocation.png")} /></p>
    <p><img alt="CreateNewApplication.png" src={require("../images/CreateNewApplication.png")} /></p>
    <p>{`Now,`}</p>
    <ul>
      <li parentName="ul">{`Select NodeJS version`}</li>
      <li parentName="ul">{`Make environment `}<inlineCode parentName="li">{`production.`}</inlineCode></li>
      <li parentName="ul">{`Set Application Root`}</li>
      <li parentName="ul">{`And application startup file as `}<inlineCode parentName="li">{`server.js`}</inlineCode></li>
    </ul>
    <p><img alt="ApplicationRoot.png" src={require("../images/ApplicationRoot.png")} /></p>
    <p>{`You can get the Application Path from your cPanel file manager
`}<img alt="FindOutPath.png" src={require("../images/FindOutPath.png")} /></p>
    <p>{`After create NodeJS app, `}<inlineCode parentName="p">{`install all the packages`}</inlineCode>{` and `}<inlineCode parentName="p">{`restart the app`}</inlineCode>{`,`}</p>
    <p><img alt="RunApp.png" src={require("../images/RunApp.png")} /></p>
    <p>{`For `}<inlineCode parentName="p">{`admin`}</inlineCode>{`,`}</p>
    <p>{`Similarly, create a another NodeJS application for admin with `}<inlineCode parentName="p">{`admin subdomain`}</inlineCode>{` and `}<inlineCode parentName="p">{`admin subdirectory`}</inlineCode></p>
    <blockquote>
      <p parentName="blockquote">{`After installing and run both NodeJS application, you can access your domain to check PickBazar,`}</p>
    </blockquote>
    <p>{`Thank You!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      